export const CATEGORIES_ACTION_TYPE = {
    SET_CATEGORIES: "SET_CATEGORIES"
}